import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterViewIndex from '@/views/RouterViewIndex.vue';
import i18n from '@/i18n/index.js';
Vue.use(VueRouter);

export default [
  {
    path: '',
    name: 'home-page',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '',
    name: 'home-page-index',
    component: RouterViewIndex,
    redirect: {
      name: 'home-page',
    },
    children: [
      {
        path: 'faqs',
        name: 'faqs',
        component: () => import('@/views/Faqs.vue'),
        meta: {
          title: i18n.t('常見問題'),
        },
      },
      {
        path: 'exam-verify',
        name: 'exam-verify',
        component: () => import('@/views/Exam/ExamVerify.vue'),
        meta: {
          title: i18n.t('檢定行政人員'),
          requireAuth: true,
        },
      },
      {
        path: 'announcement-list',
        name: 'announcementList-index',
        component: RouterViewIndex,
        redirect: {
          name: 'announcementList',
          params: {
            pagination: 1,
          },
        },
        meta: {
          title: i18n.t('最新資訊'),
        },
        children: [
          {
            path: ':pagination',
            name: 'announcementList',
            component: () =>
              import('@/views/Announcement/AnnouncementList.vue'),
            meta: {
              title: i18n.t('最新資訊'),
            },
          },
          {
            path: 'announcement/:id',
            name: 'announcement',
            component: () => import('@/views/Announcement/Announcement.vue'),
            meta: {
              title: i18n.t('最新資訊'),
              key: 'announcement',
            },
          },
        ],
      },
    ],
  },
];
